import { Searchables } from '../components/atomic/searchables.vue';
Vue.component('searchables', Searchables);